import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import { setOnRefreshToken, setOnUnauthorized } from '~/apis/axiosClient';

import authReducer from '~/thunks/auth/authSlice';
import { handleLogout, handleRefreshToken } from '~/thunks/auth/authThunk';
import deviceReducer from '~/thunks/device/deviceSlice';
import jobReducer from '~/thunks/job/jobSlice';
import projectReducer from '~/thunks/project/projectSlice';
import masterReducer from '~/thunks/master/masterSlice';
import { adminRouteAbsolute } from '~/utils/constants/route';
import commonReducer from '~/thunks/common/commonSlice';
import accountReducer from '~/thunks/account/accountSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  job: jobReducer,
  project: projectReducer,
  device: deviceReducer,
  master: masterReducer,
  common: commonReducer,
  account: accountReducer,
});

export function makeStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    devTools: process.env.NODE_ENV !== 'production',
  });
}

const store = makeStore();

setOnUnauthorized(async () => {
  store.dispatch(handleLogout());
  setTimeout(() => {
    window.location.href = adminRouteAbsolute.login;
  }, 3000);
});

setOnRefreshToken(async () => {
  const result = await store.dispatch(handleRefreshToken());
  const payload = result.payload as { access_token: string };
  return { access_token: payload.access_token };
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export default store;
